var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploaded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 -31 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m90 300h122.761719c7.613281-83.96875 78.320312-150 164.238281-150 25.226562 0 49.058594 5.859375 70.464844 16.023438-11.609375-39.996094-46.148438-70.398438-89.507813-75.203126-13.214843-52.558593-61.039062-90.820312-115.957031-90.820312-42.613281 0-83.105469 23.230469-104.433594 60.027344-36.929687-1.710938-71.105468 27.070312-76.554687 65.230468-35.949219 12.246094-61.011719 46.230469-61.011719 84.742188 0 49.628906 40.371094 90 90 90zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m377 180c-74.441406 0-135 60.558594-135 135s60.558594 135 135 135 135-60.558594 135-135-60.558594-135-135-135zm-15 201.210938-55.605469-55.605469 21.210938-21.210938 34.394531 34.394531 64.394531-64.394531 21.210938 21.210938zm0 0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploaded);
export default __webpack_public_path__ + "static/media/uploaded.1dc50c43.svg";
export { ForwardRef as ReactComponent };